import {DataStatus, Preview, PreviewAction} from 'platform/components';
import {Box, Text} from 'platform/foundation';
import {Lightbox, useLightbox, useLightboxActionsFactory} from 'platform/lightbox';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetPreviewFromSettingsQuery} from '@dms/api/core';
import {UpdateWatermarkRequestBody, UpdateWatermarkV2RequestBody} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {buildArray} from 'shared/web';

interface WatermarkDetailPreviewProps {
  watermarkData: UpdateWatermarkRequestBody | UpdateWatermarkV2RequestBody;
}

export function WatermarkDetailPreview(props: WatermarkDetailPreviewProps) {
  const {base64Url, isLoading, isFetching, isError} = useGetPreviewFromSettingsQuery(
    props.watermarkData,
    {
      skip: !props.watermarkData.fileId,
      selectFromResult: ({data, ...res}) => ({
        ...res,
        base64Url: data && `data:image/png;base64, ${data.content}`,
      }),
    }
  );

  const [lightboxControls, {onOpen}] = useLightbox('watermarkDetailPreview');
  const lightboxActionsFactory = useLightboxActionsFactory();

  const handleOpen = () => {
    onOpen(0);
  };

  return (
    <>
      <Text color="secondary" size="xSmall">
        {i18n.t('entity.watermark.labels.preview')}
      </Text>
      <Box height={45} width={45}>
        <DataStatus
          minHeight="100%"
          isLoading={isLoading || isFetching}
          isError={isError}
          isEmpty={!base64Url || !props.watermarkData.fileId}
        >
          <>
            <Preview
              url={base64Url ?? ''}
              width={45}
              height={45}
              makeUrl={() => base64Url ?? ''}
              shouldUseOriginal
              fit="contain"
              actions={buildArray<PreviewAction>().add({
                icon: 'action/visibility',
                onClick: handleOpen,
              })}
              data-testid={testIds.vehicles.photos('watermarkDetailPreview')}
            />
            {isNotNilOrEmpty(base64Url) && (
              <Lightbox
                data-testid={testIds.vehicles.photos('watermarkDetailPreview')}
                controls={lightboxControls}
                images={lightboxActionsFactory.addFullActions([
                  {
                    id: 'watermarkDetailPreview',
                    url: base64Url?.toString()?.replace('resize', 'get') ?? '',
                  },
                ])}
              />
            )}
          </>
        </DataStatus>
      </Box>
    </>
  );
}
